import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core';

@Directive({
  selector: '[idpSetFocus]'
})
export class SetFocusDirective {
  @Input() allowFocusChange = true;
  @Output() setFocusChange = new EventEmitter<boolean>();

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly elementRef: ElementRef<HTMLElement>
  ) {}

  private _setFocus = false;

  @Input() set setFocus(value: boolean) {
    if (this.allowFocusChange && this._setFocus !== value) {
      this._setFocus = value;
      this.assignElementAction();
    }
  }

  @HostListener('blur') onBlur() {
    if (this.allowFocusChange) {
      this._setFocus = false;
      setTimeout(() => {
        this.setFocusChange.emit(this._setFocus);
        this.changeDetectorRef.detectChanges();
      });
    }
  }

  @HostListener('focus') onFocus() {
    if (this.allowFocusChange) {
      this._setFocus = true;
      setTimeout(() => {
        this.setFocusChange.emit(this._setFocus);
        this.changeDetectorRef.detectChanges();
      });
    }
  }

  assignElementAction() {
    if (this._setFocus) {
      setTimeout(() => {
        this.elementRef.nativeElement.focus();
      });
    } else {
      setTimeout(() => {
        this.elementRef.nativeElement.blur();
      });
    }
  }
}
